import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'l-animated-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './animated-banner.component.html',
  styleUrls: ['./animated-banner.component.scss']
})
export class AnimatedBannerComponent {}